var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "767.1px",
    height: "639.1px",
    viewBox: "0 0 767.1 639.1",
    style: {
      enableBackground: "new 0 0 767.1 639.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EBEBEB;}\r\n\t.st1{fill:#F5F5F5;}\r\n\t.st2{fill:#E6E6E6;}\r\n\t.st3{fill:#E0E0E0;}\r\n\t.st4{fill:#EF9E29;}\r\n\t.st5{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st6{fill:#F42C57;}\r\n\t.st7{fill:#F42F5E;}\r\n\t.st8{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st9{fill:#263238;}\r\n\t.st10{fill:#24212B;}\r\n\t.st11{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st12{fill:#7E57C2;}\r\n\t.st13{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st14{fill:#41B3CE;}\r\n\t.st15{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st16{opacity:0.2;}\r\n\t.st17{opacity:0.3;enable-background:new    ;}\r\n\t.st18{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st19{opacity:0.2;enable-background:new    ;}\r\n\t.st20{fill:#E4897B;}\r\n\t.st21{fill:#FFFFFF;}\r\n\t.st22{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st23{fill:#E5E533;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-193"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -33.2,
    y: 555.4,
    className: "st0",
    width: 844.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 582.6,
    className: "st0",
    width: 56,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.7,
    y: 587.2,
    className: "st0",
    width: 14.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.8,
    y: 566.9,
    className: "st0",
    width: 32.4,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.4,
    y: 569.7,
    className: "st0",
    width: 73,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 569.7,
    className: "st0",
    width: 10.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.9,
    y: 576.8,
    className: "st0",
    width: 158.3,
    height: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 533.5,
    cy: 159.8,
    r: 70.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M658.7,146c0-6.3-5.1-11.4-11.4-11.4c-1.1,0-2.2,0.2-3.3,0.5c0.2-1.2,0.2-2.3,0.3-3.5 c0-13.4-10.8-24.2-24.1-24.2c-1.5,0-3.1,0.1-4.6,0.4c-6.1-10-19.1-13.2-29.1-7.1c-6.2,3.8-10,10.5-10.2,17.8h-0.4 c-10.8,0.3-19.2,9.3-18.9,20.1c0.3,10.3,8.6,18.6,18.9,18.9h71.7C653.8,157.2,658.7,152.2,658.7,146z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.1,208.9c0-6.3-5.1-11.4-11.4-11.4c-1.1,0-2.3,0.2-3.4,0.5c2-13.2-7.1-25.5-20.3-27.5 c-1.2-0.2-2.5-0.3-3.7-0.3c-1.5,0-3,0.1-4.5,0.4c-6.1-9.9-19.2-13-29.1-6.9c-6.1,3.8-9.9,10.4-10,17.5h-0.4 c-10.8,0.3-19.2,9.3-18.9,20.1c0.3,10.3,8.6,18.6,18.9,18.9h71.6C473.1,220.2,478,215.1,478.1,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.8,230.6c0-6.3-5.1-11.4-11.4-11.4c-1.1,0-2.3,0.2-3.4,0.5c0.2-1.2,0.3-2.3,0.3-3.5 c0-13.4-10.9-24.3-24.3-24.2c-1.5,0-2.9,0.1-4.4,0.4c-6.1-10-19.1-13.2-29.1-7.1c-6.2,3.8-10.1,10.5-10.2,17.8h-0.4 c-10.8,0.3-19.2,9.3-18.9,20.1c0.3,10.3,8.6,18.6,18.9,18.9h71.6C157.8,241.9,162.8,236.8,162.8,230.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M652.1,285.1c0-3.8-3.1-6.9-6.9-6.9c-0.7,0-1.3,0.1-2,0.3c1.2-8-4.4-15.4-12.4-16.6c-0.7-0.1-1.4-0.2-2.1-0.2 c-0.9,0-1.8,0.1-2.7,0.3c-3.7-6-11.6-7.8-17.6-4.1c-3.7,2.3-5.9,6.3-6,10.6h-0.4c-6.5,0-11.8,5.3-11.8,11.8 c0,6.5,5.3,11.8,11.8,11.8l0,0h43.3C649.1,292,652.2,288.9,652.1,285.1C652.1,285.1,652.1,285.1,652.1,285.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.5,62.9c0-3.8-3-6.9-6.8-6.9c-0.7,0-1.4,0.1-2.1,0.3c1.2-8-4.4-15.4-12.4-16.6c-0.7-0.1-1.4-0.2-2.1-0.2 c-0.9,0-1.8,0.1-2.7,0.3c-3.7-6-11.6-7.8-17.6-4.1c-3.7,2.3-5.9,6.3-6,10.6h-0.2c-6.5,0-11.8,5.3-11.8,11.8s5.3,11.8,11.8,11.8 h43.3C231.6,69.7,234.5,66.6,234.5,62.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "118.6,321 164.4,528.8 172.7,524.9 124.6,319.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M643.9,527.8c0,0-28.4-195.3,35.4-397.2l-10-7.7c0,0-74.6,152.7-63.7,410.4L643.9,527.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M696.7,77.5c23.3-15.3,57.9,9,62.6,47.1c-3.4-2-7-3.7-10.7-5.1c-1.8-9.6-3.5-18-3.5-18l1.3,17.2 c-2.1-0.7-4.3-1.5-6.8-2.1l-1.7-9.2l-0.8,8.6c-3.3-0.8-6.7-1.3-10-1.7l-4.4-27l-2.2,26.5c-3.5-0.1-6.9,0.1-10.4,0.5l-2.7-18.3v18.7 c-3,0.5-5.9,1.1-8.8,2l-3.2-27.4c0,0,0.1,15.4-0.1,28.5c-8.3,3-15.9,7.5-22.5,13.2l-0.3-3.4C672.6,127.5,675.3,91.5,696.7,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M664.4,65.3c-18.6-20.9-58.3-6.4-72.8,29.1c3.8-1,7.7-1.7,11.7-2.1c4.2-8.8,8.1-16.5,8.1-16.5L605.7,92 c2.2-0.2,4.5-0.3,7-0.3l4-8.4l-1.5,8.5c3.4,0.1,6.8,0.4,10.1,0.9l11.3-24.9L631.9,94c3.4,0.8,6.7,1.9,9.9,3.1l7.4-17l-4.8,18 c2.7,1.2,5.4,2.6,7.9,4.2l10.3-25.6c0,0-4.1,14.8-7.4,27.5c7.2,5.1,13.4,11.4,18.3,18.7l1.1-3.2C674.5,119.8,681.3,84.4,664.4,65.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M646.5,114.8c18.6-18.1,32.5-2.3,32.5-2.3c-7,1.8-13.2,6.3-18.6,12l-2.5-3.3l0.4,5.6c-1.3,1.5-2.5,3-3.7,4.6 l-4.3-9.7l1.8,13.1c-1.7,2.5-3.4,5.1-4.8,7.6l-1.9-9.6l0.2,12.7c-1.6,2.9-2.9,5.7-4.2,8.3l-2-17.6l-0.3,22.8c-3,7-4.5,12-4.5,12 S627.9,132.9,646.5,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M696.7,157.6l-3.8,2.2c-0.6-3-1.2-6-1.9-9.2l2.6-4.8l-3.3,2c-0.3-1-0.5-2.1-0.8-3.1l3.4-9.4l-5.1,3.7 c-2.7-8.4-6.2-15.9-10.5-19.4c0,0,42.6,13.6,18.6,59.6c0,0-0.8-7.3-2.5-16.8L696.7,157.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M654.8,120.1l-6.8-12.8l2.8,13.4c-0.7,0.1-1.4,0.2-2.1,0.4l-8.8-11l2.2,12.7c-3,0.9-6,2-8.9,3.3 c-3.1,1.4-6.2,3-9.2,4.7l-4.3-11.2l2,12.6c-2.9,1.7-5.8,3.6-8.4,5.5l-2.1-9.9l0.2,11.3c-3.4,2.4-6.5,4.9-9.4,7.3l0.3-17.9 l-2.6,19.9c-3,2.5-5.7,5-7.9,7.1l-0.3-12.5l-3.2,15.8c-3.3,3.3-5.2,5.3-5.2,5.3c1.7-43.6,18.6-60.8,46.5-65.6 c27.9-4.7,48.1,24.3,48.1,24.3S668.9,118.6,654.8,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M736.3,173.3l-2.6,13.1c-1.2-3.2-2.9-7.4-5.1-12l2.3-19l-4.2,15c-3.3-6.8-7.1-13.4-11.4-19.6l4-13.2l-6.5,9.8 c-1.3-1.7-2.6-3.4-4-4.9l2.3-8.3l-3.5,6.9c-0.9-1-1.9-2-2.9-3l2.8-11.1l-4.4,9.6c-2.7-2.5-5.7-4.7-8.9-6.5l4.4-13.5l-7,12.3 c-4.4-2.1-9.2-3.1-14-2.9c0,0,8.4-13.5,24-18.2s49,23.5,34.5,85.5c0,0-0.4-1.4-1.3-3.8L736.3,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M710.7,52.8l2.7,7.9c-1,0.1-2,0.2-2.9,0.4l-3.2-10.3l2.1,10.5c-2,0.6-4,1.5-5.7,2.6l-4.4-13.8l2.5,15.1 c-0.7,0.5-1.4,1.1-2.1,1.7l-5-13l3.7,14.2c-3.7,3.7-6.8,7.9-9.3,12.4l-1.3-19.2l-2.2,26c-3.6,8.1-6.6,16.6-8.8,25.2 c0,0-2.7-69.3,14-77S717.3,61,717.3,61c-0.7-0.2-1.5-0.3-2.3-0.4L710.7,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M686.8,129.9l-1.5,13.1l-5.1-12.7l-6.8,9.9l-2.7-9.2l-7.8,6.6c0,0,1-16.7,5.9-24.4 C674,105.5,688.9,110.9,686.8,129.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.7,340.9v-91.5c0,0-18.6,19.8-30.9,17c-12.3-2.7-28.3,6.6-28.3,6.6s16.1-2.3,22.1,4.2s32.7,7.2,32.7,7.2 v59.8L478.7,340.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "560.7,312.9 556.4,312.9 556.4,318.6 542.5,318.6 542.5,312.9 528.8,312.9 528.8,318.6 514.9,318.6  514.9,312.9 501.2,312.9 501.2,318.6 487.3,318.6 487.3,312.9 473.6,312.9 473.6,318.6 459.7,318.6 459.7,312.9 446,312.9  446,318.6 432.1,318.6 432.1,312.9 418.4,312.9 418.4,318.6 404.5,318.6 404.5,312.9 399.8,312.9 386.2,421.4 574.7,420.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "590.6,391.6 584.8,391.6 584.8,399.5 565.7,399.5 565.7,391.6 546.9,391.6 546.9,399.5 527.8,399.5  527.8,391.6 509,391.6 509,399.5 489.9,399.5 489.9,391.6 471.1,391.6 471.1,399.5 451.9,399.5 451.9,391.6 433.1,391.6  433.1,399.5 414,399.5 414,391.6 395.2,391.6 395.2,399.5 376.1,399.5 376.1,391.6 369.7,391.6 351,540.7 609.9,539.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M686.3,523.1c-4-4.5-7.8-9.1-12-13.5c-0.2-0.2-0.4-0.5-0.6-0.7c-1.4-0.9-2.8-1.7-4.3-2.4 c-0.3-0.1-1.1-0.4-2-0.8c-1.7-0.6-3.4-1.3-5.1-1.9c-10.5-4.2-19.9-9.1-27.8-17.5c-4.3-4.6-7.8-9.9-12.3-14.3 c-0.1,0.2-1-0.3-1.4-0.7l-3.4-0.4c-1.8,0-3.6,0-5.4,0.1c-2.6,0.1-5.2,0.3-7.8,0.6c-10.1,14.7-22.8,34.9-28.4,37.5 c-8.7,4.1-88.9,25.3-94.8,24c-5.9-1.3-36.9,1.3-44.6,1c-7.8-0.3-21.8-3.7-42.2-13.1c-20.4-9.4-31.5-9.4-56.1-17.3 c-24.5-7.8-41-10.8-55.4,1.2c-14.4,12-53.8-13.4-66.1-17c-12.3-3.6-35.8-24.4-51.9-14.7c-16.1,9.7-29.4,14.3-49.5,31.7 s-59.8,50.9-59.8,50.9h677.5l-7.8-13.6C710.1,541.4,696.1,534.5,686.3,523.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.7,357c0,0,19.7-35.5,73.1-66.1c0,0,43.5-3.7,92.6,17.7c0,0,10,16.5-1.4,23c-11.3,6.5-20.7-6.6-20.7-6.6 s-2.1,20-16.9,20.5c-14.8,0.6-19.1-14-19.1-14s-1.5,18.3-19.1,23c-15.2,4.1-24.7-9-24.7-9s-3,15.1-16.7,19.4c-11,3.5-18.6-6-18.6-6 s-3.2,16.4-14.9,16.4C43.4,375.4,39.7,357,39.7,357z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-193"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-193",
    className: "st1",
    cx: 389.2,
    cy: 612.5,
    rx: 327.6,
    ry: 19.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sand--inject-193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M615.6,529.2c0,0,7.3-10.8,14-13.8c6.7-3,7.8-14.4,11.4-15.1c3.6-0.6,7.6,9.9,14,13c6.4,3.1,16,15.8,16,15.8 L615.6,529.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M615.6,529.2c0,0,7.3-10.8,14-13.8c6.7-3,7.8-14.4,11.4-15.1c3.6-0.6,7.6,9.9,14,13c6.4,3.1,16,15.8,16,15.8 L615.6,529.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "669,606.7 615.5,606.7 608.8,529.1 675.7,529.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.5,
    y: 525.1,
    className: "st7",
    width: 73.4,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.5,
    y: 525.1,
    className: "st8",
    width: 73.4,
    height: 8.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M639.1,530.9c4.9,7.6,25.7,39.1,38.6,41.4l1.6-3.8c0,0-11.6,1.4-37.2-39.6c-0.5-0.8-1.6-1.1-2.4-0.7l0,0 c-0.9,0.5-1.2,1.6-0.7,2.5C639.1,530.8,639.1,530.8,639.1,530.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M563,506.4L563,506.4c2.3-0.7,4.7,0.5,5.4,2.8c0,0,0,0.1,0,0.1l9.1,31.9l11.8-4.7c0,0,7.1,26.6-6.4,30.8 c-13.1,4.1-23.3-20.5-23.3-20.5l12.1-3.4l-11.5-31.5C559.5,509.7,560.7,507.2,563,506.4C563,506.4,563,506.4,563,506.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M583.1,567.3c-13.2,4.1-23.3-20.5-23.3-20.5l12.1-3.4c0,0,2.1,3.5,4.4,2.7s1.4-5,1.4-5l11.8-4.7 C589.5,536.4,596.6,563.1,583.1,567.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M684.3,613.2c-6.6-3.3-13.4-6.4-15.6-6.6c-4.7-0.3-7.3-2.4-10.7-6.4s-4.7-8.6-10.7-15c-6-6.4,0.7-9-12-10.6 s-7.8-0.6-15.6-6.2c-7.8-5.6-6.2-5.6-15.4-9.6c-9.1-4-3.8-5.5-14.5-6.4c-7.4-0.6-19.1,3.3-25.1,7.6c-2.7,1.9-4.1,5.1-6.8,6.8 c-3,1.9-7.6-1.7-7.1,4.7c0.3,1.6,0.4,3.3,0.2,5c-0.9,3.6-15.7,3.6-19.5,4.7c-0.9,0.2-1.7,0.7-2.3,1.4c-0.9,1.5,0.4,4.3-1.2,4.8 c-0.5,0.2-1.1,0-1.7,0.1c-2,0.4-1.5,4-3.4,4.8c-1.9,0.8-4.1-0.9-6.2,0c-1.6,0.6-2.1,2.8-3.5,3.6c-2.4,1.5-5,2.6-7.4,4.2 c-4.2,2.7-7.8,6.1-12.3,8.4l-12,3.3l-3.6,1.3L684.3,613.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M684.3,613.2c-6.6-3.3-13.4-6.4-15.6-6.6c-4.7-0.3-7.3-2.4-10.7-6.4s-4.7-8.6-10.7-15c-6-6.4,0.7-9-12-10.6 s-7.8-0.6-15.6-6.2c-7.8-5.6-6.2-5.6-15.4-9.6c-9.1-4-3.8-5.5-14.5-6.4c-7.4-0.6-19.1,3.3-25.1,7.6c-2.7,1.9-4.1,5.1-6.8,6.8 c-3,1.9-7.6-1.7-7.1,4.7c0.3,1.6,0.4,3.3,0.2,5c-0.9,3.6-15.7,3.6-19.5,4.7c-0.9,0.2-1.7,0.7-2.3,1.4c-0.9,1.5,0.4,4.3-1.2,4.8 c-0.5,0.2-1.1,0-1.7,0.1c-2,0.4-1.5,4-3.4,4.8c-1.9,0.8-4.1-0.9-6.2,0c-1.6,0.6-2.1,2.8-3.5,3.6c-2.4,1.5-5,2.6-7.4,4.2 c-4.2,2.7-7.8,6.1-12.3,8.4l-12,3.3l-3.6,1.3L684.3,613.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M542.5,582.5c0,0.1,0,0.2,0,0.4l0,0c0,5.7-1.7,11.3-4.8,16.1c-0.3,0.4-0.5,0.8-0.8,1.2 c-1.8,2.5-3.9,4.8-6.4,6.6c-0.5,0.4-1.1,0.9-1.7,1.2l0,0c-0.1,0.1-0.3,0.2-0.4,0.3l-0.6,0.4c-0.3,0.2-0.6,0.4-0.9,0.5 c-0.5,0.3-1,0.5-1.5,0.8l0,0c-12.1,6.1-26.7,3.5-36-6.3c-2.1-2.1-3.8-4.6-5.2-7.2c-2.2-4.3-3.4-9.1-3.4-14v-0.1 c0-0.9,0-1.7,0.1-2.6c0.3-4,1.4-7.8,3.3-11.4c0.4-0.9,0.9-1.8,1.5-2.6c1.8-2.7,4-5.2,6.5-7.3c0.8-0.7,1.6-1.3,2.5-1.8 c0.3-0.2,0.6-0.4,0.9-0.6c2.4-1.5,5-2.6,7.8-3.4l0.7-0.2c2.4-0.6,5-0.9,7.5-0.9c0.8,0,1.6,0,2.3,0.1h0.6l0,0 c3.4,0.3,6.8,1.2,9.9,2.7l0.4,0.2c9.4,4.4,15.9,13.4,17.3,23.7l0,0C542.4,579.7,542.5,581.1,542.5,582.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M542.5,582.5c0,11.7-6.6,22.3-17,27.5l0,0c-0.7-0.6-1.3-1.3-1.7-2.1c5.7-16.6,0-25.4,0-25.4v-0.2l0.4-2.7 v-0.5c0.9-4.9,3.1-14.1,7.9-19.7C538.7,565.3,542.5,573.7,542.5,582.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M488.2,577.2c0,0-5.4,5.4-3.8,19.3c-6.6-12.9-3.3-28.7,8-37.9C489.3,564.3,487.9,570.7,488.2,577.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M532.2,559.5c-6.8,7.8-8.4,23-8.4,23c-18.6,4.5-35.6-5.3-35.6-5.3c-0.2-6.5,1.2-12.9,4.2-18.6 C504,549.1,520.8,549.4,532.2,559.5L532.2,559.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M525.4,610c-12.1,6-26.6,3.5-35.9-6.3c5.8,3.4,17.5,8.2,34.2,4.2C524.2,608.7,524.7,609.4,525.4,610z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.9,554.7c-0.8,1.1-1.5,2.3-2.2,3.5c-1.3,2.3-2.3,4.7-3.2,7.2c-0.9,2.5-1.7,5.1-2.4,7.6c-0.7,2.5-1.3,5.2-1.7,7.8 c0.2-2.7,0.5-5.3,1.1-7.9c0.6-2.6,1.3-5.2,2.2-7.7c0.9-2.5,2.1-4.9,3.4-7.3c0.7-1.2,1.5-2.3,2.4-3.4L524.9,554.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.7,551.9c-0.4,0.8-0.8,1.5-1.2,2.3c-1.2,2.6-2.3,5.3-3.1,8.1c-0.9,2.8-1.6,5.6-2.2,8.4s-1.2,5.7-1.7,8.6 c0.2-2.9,0.5-5.8,1-8.7c0.5-2.9,1.2-5.7,2-8.5c0.8-2.8,1.9-5.6,3.3-8.2c0.4-0.7,0.8-1.4,1.2-2L514.7,551.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.3,552.6l-0.5,1.4c-0.9,2.5-1.7,5.1-2.3,7.7c-0.7,2.6-1.2,5.2-1.7,7.9c-0.5,2.7-0.9,5.3-1.3,8 c0.1-2.7,0.3-5.4,0.7-8.1c0.4-2.7,0.9-5.4,1.5-8c0.6-2.6,1.4-5.2,2.5-7.8c0.1-0.3,0.3-0.6,0.4-0.9L504.3,552.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.8,556.2c-0.6,1.9-1.1,3.8-1.5,5.7c-0.4,1.9-0.8,4.3-1.2,6.5c-0.3,2.2-0.6,4.4-0.8,6.6c-0.1-2.2-0.1-4.4,0.1-6.7 c0.2-2.2,0.5-4.4,1-6.6c0.4-1.7,0.8-3.3,1.4-4.9C495.2,556.6,495.5,556.4,495.8,556.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.4,592.7c0.1,3.2-0.3,6.4-1.2,9.4c-0.5,1.5-1,3-1.7,4.4c-0.2,0.5-0.5,1-0.7,1.5l0,0c-0.1,0.1-0.3,0.2-0.4,0.3 c0.9-2,1.7-4.2,2.2-6.3c0.8-3,1.1-6.1,1-9.2c0-3.1-0.5-6.2-1.4-9.2c-0.9-3-2.1-5.9-3.7-8.6c1.9,2.6,3.3,5.4,4.3,8.4 C531.7,586.4,532.3,589.6,532.4,592.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.5,591.9l-0.1,2.6L538,597c-0.1,0.7-0.2,1.4-0.4,2c-0.3,0.4-0.5,0.8-0.8,1.2c0.3-1.1,0.4-2.2,0.5-3.3l0.3-2.5v-2.5 c0.1-0.8,0.1-1.7,0-2.5c-0.1-0.8-0.1-1.7-0.2-2.5c-0.4-3.3-1.2-6.6-2.5-9.7c-1.2-3.1-2.9-6.1-5-8.7c2.3,2.5,4.2,5.3,5.6,8.4 c1.4,3.1,2.3,6.4,2.7,9.8c0.1,0.8,0.1,1.7,0.2,2.6C538.5,590.2,538.5,591,538.5,591.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.5,582.5c0,0.1,0,0.2,0,0.4l-0.1-0.6c-0.7-3.5-1.9-6.9-3.4-10.1c-1.5-3.3-3.5-6.3-5.8-9c2.6,2.5,4.8,5.5,6.4,8.7 c1.1,2.1,2,4.3,2.7,6.6l0,0C542.4,579.8,542.5,581.1,542.5,582.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.7,572.3c-1.4,1.5-2.5,3.2-3.5,5.1c-0.9,1.6-1.6,3.3-2.2,5.1c0-0.9,0-1.7,0.1-2.6c0.5-1,1-1.9,1.5-2.8 C483.7,575.2,485,573.6,486.7,572.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.1,564.1c-1.3,1.5-2.5,2.9-3.8,4.3c0.4-0.9,0.9-1.8,1.5-2.6C486.6,565.3,487.3,564.7,488.1,564.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.1,583.7c2.8,1.1,5.6,2,8.4,2.9c2.9,0.8,5.8,1.5,8.7,2.1c5.9,1.3,11.9,1.2,17.7-0.2c-2.8,1.1-5.8,1.6-8.9,1.7 c-3,0.1-6.1-0.2-9-0.7c-3-0.6-5.9-1.3-8.8-2.3C493.5,586.2,490.8,585,488.1,583.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.1,591c2.8,1.1,5.7,2.1,8.7,2.8c2.9,0.8,5.9,1.3,8.9,1.7c3,0.4,6,0.6,9.1,0.4l2.3-0.1l2.3-0.3c1.5-0.1,3-0.5,4.5-0.8 c-2.9,1-5.9,1.6-9,1.8c-3.1,0.2-6.1,0.1-9.2-0.2c-3-0.4-6-1-9-1.9C493.7,593.6,490.8,592.5,488.1,591z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.9,597.4c2.7,1.2,5.4,2.3,8.2,3.1c2.8,0.8,5.7,1.4,8.6,1.7c1.5,0.2,2.9,0.3,4.4,0.4c1.5,0.1,2.9,0,4.4-0.1 c2.9-0.2,5.8-0.6,8.7-1.3c-2.8,1-5.7,1.6-8.6,1.9c-3,0.3-5.9,0.3-8.9-0.1c-2.9-0.4-5.9-1-8.7-2 C494.1,600.1,491.4,598.9,488.9,597.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.1,602.2c2.5,1.2,5.1,2.1,7.8,2.9c2.6,0.8,5.3,1.4,8.1,1.7c2.7,0.4,5.5,0.5,8.2,0.3l2.1-0.2l2-0.3 c1.4-0.1,2.7-0.6,4.1-0.9c-2.6,1-5.3,1.7-8.1,2c-2.8,0.3-5.6,0.3-8.4,0c-2.8-0.4-5.5-1-8.2-1.9C495,604.9,492.5,603.7,490.1,602.2 z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--travel-bag--inject-193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M159,534.1c0,0,6-9,16.7-9.7c10.7-0.7,19.7,13,19.7,13h-3.4c0,0-8.6-9.3-14.8-9.3c-6.2,0-12.2,7.7-12.2,7.7 L159,534.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M68.3,605.5c3.7-6.2,45.1-2.2,54.5-5.8l5.1,8.7c0,0-7.1,4-19,2.6c-11.9-1.4-29.8-1.8-34.5,2.3L68.3,605.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M68.3,605.5c3.7-6.2,45.1-2.2,54.5-5.8l5.1,8.7c0,0-7.1,4-19,2.6c-11.9-1.4-29.8-1.8-34.5,2.3L68.3,605.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M242.9,586.7c-0.3,1.5-0.7,2.9-1.1,4.3c-3.4,11.5-8.6,20.8-12.4,22.3H121.9c-3,0-5.8-1.4-7.7-3.8l-0.1-0.1 c-0.4-0.5-0.7-1.1-1-1.7c-7.4-15.5-14.9-46.5-4.4-60.6c1.1-1.5,2.4-2.8,3.8-4l0.3-0.2c2.2-1.8,4.7-3.3,7.3-4.5h0.1 c7.4-3.4,16.5-4.9,25.3-5.5c2.6-0.2,5.1-0.3,7.7-0.4c6.6-0.2,12.7,0,17.6,0.1c17.3,0.4,30.9,5.6,40.1,4.7c3.4-0.4,6.8-0.1,10.1,0.8 c1,0.3,1.9,0.6,2.8,0.9c4.2,1.8,8.1,4.2,11.6,7.1C246.2,554.6,246.4,571.8,242.9,586.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M242.9,586.7c-0.3,1.5-0.7,2.9-1.1,4.3c-3.4,11.5-8.6,20.8-12.4,22.3H121.9c-3,0-5.8-1.4-7.7-3.8l-0.1-0.1 c-0.4-0.5-0.7-1.1-1-1.7c-7.4-15.5-14.9-46.5-4.4-60.6c1.1-1.5,2.4-2.8,3.8-4l0.3-0.2c2.2-1.8,4.7-3.3,7.3-4.5h0.1 c7.4-3.4,16.5-4.9,25.3-5.5c2.6-0.2,5.1-0.3,7.7-0.4c6.6-0.2,12.7,0,17.6,0.1c17.3,0.4,30.9,5.6,40.1,4.7c3.4-0.4,6.8-0.1,10.1,0.8 c1,0.3,1.9,0.6,2.8,0.9c4.2,1.8,8.1,4.2,11.6,7.1C246.2,554.6,246.4,571.8,242.9,586.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M226.4,585.6c-7.7,0-23.1,3.7-45.8-1.3c-10.6-2.5-21.6-2.6-32.3-0.2c-0.3-3.4-0.5-7.1-0.8-11.2 c-2-27.5-17.7-39-27.2-34.4h-0.1c-2.6,1.2-5,2.7-7.3,4.5l-0.3,0.2c-1.4,1.2-2.7,2.5-3.8,4c-10.5,14.1-3,45.1,4.4,60.6 c0.3,0.6,0.6,1.2,1,1.7l0.1,0.1c1.8,2.1,4.5,3.3,7.3,3.3h19.2c7.9,0,8.8-7.2,7.9-22.7c1.3-0.8,3-1.7,4.8-2.9 c4.8-3.1,23.4-1.6,31.4,1.4c8,3,29.1,4.3,39.3,2.7c5.8-0.9,11.7-1,17.5-0.3c0.4-1.4,0.8-2.8,1.1-4.3 C239.3,586.3,232,585.6,226.4,585.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M156.5,546.8c4.7,17,7.9,23.1,9.1,24.7c1.2,1.7,35.3,5.7,41.6,5.7c7.4-0.1,14.7-0.8,22-2.2 c4.3-1.1,5.7-23-5.2-36.1c-0.9-0.4-1.9-0.7-2.8-0.9c6,13.4,6.1,29.8,5.4,32.1c-1,3.2-11,2.8-15.7,2.7c-4.7-0.1-33.8-1.9-36.8-3.1 c-2.9-1.2-5.3-3.2-7-5.8c-2.3-3-2.7-13.4-6.9-22.3c-1.8-3.4-4.1-6.5-6.9-9.1c-2.5,0-5.1,0.2-7.7,0.4 C151.1,535.8,155,540.9,156.5,546.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M122.8,562.5l-9.4,2.3c0,0-6.6,19.1-2.7,27c4,8-27,19.1-42.5,13.5l6,7.8c0,0,36.8-2.3,43.8-16.3 c7-14-3-16.2-3.7-20.1C113.8,572.8,122.8,562.5,122.8,562.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M122.8,562.5l-9.4,2.3c0,0-6.6,19.1-2.7,27c4,8-27,19.1-42.5,13.5l6,7.8c0,0,36.8-2.3,43.8-16.3 c7-14-3-16.2-3.7-20.1C113.8,572.8,122.8,562.5,122.8,562.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M205.5,169.5c0,0-36.2-20.3-43.6-25.5c-7.5-5.2-47.5-44.5-49.8-45.6c0,0,1.5-4.5-1.9-7.1 C106.8,88.6,93.7,80,91.9,80c-1.9,0-6.8,18.3-6,22.8s19.1,5.6,19.1,5.6s38.2,44.4,44.1,50.7c6,6.3,46.8,32.8,46.8,32.8 L205.5,169.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M220.3,173.2c0,0,7.9,16-11.3,41.4l-42.4-31.2l16.9-30.7L220.3,173.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M209,214.6l-20-14.7l-2.6-1.9l-11.3-8.2l-8.4-6.2l6.2-11.3l3.5-6.5l7.2-13l6.9,3.9l6,3.4l23.9,13.3 c0.8,1.9,1.3,3.8,1.4,5.8C222.5,185.8,221.3,198.3,209,214.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M209,214.6l-20-14.7c6.9-14.2,24.7-19.2,32.8-20.8C222.5,185.8,221.3,198.3,209,214.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "196.4,159.9 190.4,163.4 190.4,156.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "183.4,167.9 175.9,178.4 172.8,172.2 176.3,165.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "188.9,183.7 186.3,198 175,189.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "194.1,175.5 198.3,186.2 207,174.4  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M299.1,165.6c0,0,36.2-20.3,43.6-25.5c7.5-5.2,47.5-44.5,49.8-45.6c0,0-1.5-4.5,1.9-7.1 c3.4-2.6,16.5-11.2,18.3-11.2s6.8,18.3,6,22.8s-19.1,5.6-19.1,5.6s-38.2,44.5-44.1,50.7c-6,6.2-46.8,32.7-46.8,32.7L299.1,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M255.9,379.7c0,0-0.8,12.8-1.9,29.8c-0.8,10.6-1.7,22.9-2.8,34.7c-1.4,15.9-3,31.1-4.6,40.5 c-1.5,8.7-21,116.3-21,116.3h-13.1c4.1-100.4,10.5-139.3,10.7-145.1c0-1.9,0.2-4.6,0.2-7.7c0.3-11.5,0.5-29.6,0.6-42.7 c0.1-9.5,0.2-16.4,0.2-16.4L255.9,379.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M306.4,461c-0.5,8.8-5.7,139.7-5.7,139.7h-14.4c-7.3-104.3-4.6-140.5-5.9-147.7l0,0 c-2.2-12.3-4.4-28.5-5.8-40.5c-1.2-9.6-1.9-16.6-1.9-16.6l29.3-12.7c0,0,1.8,15.2,3.1,33.4c0.7,9.1,1.2,19,1.4,28.3 C306.7,450.6,306.7,456.1,306.4,461z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M224,405.5l30,4.1c-0.8,10.6-1.7,22.9-2.8,34.7l-27.8,4C223.7,436.8,223.9,418.7,224,405.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M306.6,444.9l-26.1,8c-2.2-12.3-4.4-28.5-5.8-40.5l30.5,4.2C305.8,425.7,306.4,435.6,306.6,444.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M228.7,597.1h-17.3c-0.6,0-1.1,0.4-1.2,1l-2.8,12.6c-0.2,1.1,0.5,2.2,1.6,2.5c0.2,0,0.3,0,0.5,0 c5.6-0.1,9.6-0.4,16.6-0.4c4.3,0,17.4,0.5,23.3,0.5s6.8-5.9,4.3-6.4c-10.9-2.4-19.2-5.7-22.7-8.8 C230.4,597.4,229.5,597,228.7,597.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M301.8,596.6h-17.3c-0.6,0-1.1,0.4-1.2,1l-2.8,12.7c-0.2,1.1,0.5,2.3,1.7,2.5c0,0,0,0,0,0h0.5 c5.6-0.1,9.6-0.4,16.7-0.4c4.3,0,17.3,0.4,23.3,0.4c6,0,6.8-5.9,4.3-6.4c-10.9-2.4-19.2-5.7-22.7-8.8 C303.6,596.9,302.7,596.6,301.8,596.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M257.1,436.9c0.1-1.1,0.3-2.3,0.4-3.7c1.7-17.3,3.5-38.1,5.1-58.1c5.8,15.7,8.3,37.7,11.4,61.8h35.5 c-2.9-62.2-10.6-112.8-14.7-134.4h-75.3c-0.1,7.7-1,82.8-2.9,134.4H257.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M257.1,436.9c0.1-1.1,0.3-2.3,0.4-3.7c1.7-17.3,3.5-38.1,5.1-58.1c5.8,15.7,8.3,37.7,11.4,61.8h35.5 c-2.9-62.2-10.6-112.8-14.7-134.4h-75.3c-0.1,7.7-1,82.8-2.9,134.4H257.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M267.5,148.3c-0.2,0.7-0.4,1.4-0.6,2c-1.3,3.8-3.8,7-7,9.4c-0.8,0.6-1.7,1.1-2.6,1.6 c-7,3.8-15.7,2.4-21.3-3.4c-7.1-7.2-6.9-15.5-7.7-29.5c-0.2-3,0.3-6,1.4-8.8c4.1-9.8,15.3-14.5,25.1-10.4c0,0,0,0,0,0 C268.6,114.8,270.5,135.7,267.5,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M259.8,159.7c-0.8,0.6-1.7,1.1-2.6,1.6c-4.8,2.5-10.4,2.8-15.4,0.7c0.6-1.7,1.5-3.3,2.5-4.8 C249.7,156.5,255,157.4,259.8,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M231.6,177.9c6.9,6.3,23.9,4,23.9,4s10.6-2.9,8.3-6.2c-6.2-1-9.2-3.9-10.5-7.7c-0.7-2.3-0.9-4.7-0.6-7.1 c0.1-1.3,0.3-2.7,0.5-4l-21-15.5C235,151.7,238.3,170.5,231.6,177.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M259.8,135.6l3,1.1l-1.5-6.2c0,0,4.4-6.8,0-12.6c0,0,12.2-3.7,5.3-10.1c-2.6-2.4-5.8,0-14.2-3.7 c-4.6-2-18.9-2.2-19.6,3.7c0,0-10.3,0-11.4,17.6c-0.7,10.4,3.3,20.6,10.9,27.8c0,0,12.5,2.9,18.6-2.1 C257,146,259.8,135.6,259.8,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M251.9,136.6c0.5,2.7,2.2,5,4.7,6.2c2.9,1.2,4.7-2.8,4.3-7c-0.4-3.8-2.3-9-5.4-8.3 C252.4,128.2,250.9,132.8,251.9,136.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M262.7,375c-1.6,20-3.4,40.8-5.1,58.1c-2.6-25-5.7-42.8-5.7-42.8s-2.9-2.4-11-15.3c-8.1-12.9,0-37,0-37 C240.5,360.4,262.7,375,262.7,375z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "312.1,434 310.5,439.8 272.8,439.8 272.8,434.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "259,434.8 257.8,440.2 215,440.2 212.5,434.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M264.2,173.9c0,0-6.1-9.7-21.6-10.4c-15.5-0.7-16.7,10-16.7,10L264.2,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M264.2,173.9c0,0-6.1-9.7-21.6-10.4c-15.5-0.7-16.7,10-16.7,10L264.2,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M208.6,167.8c4.7,52.6,4.1,105.5-1.7,158l90.8-5.5c-1-92.6-13.4-151-13.4-151s-23.4,4.9-42.4,4.2 C230.5,173,219.4,171,208.6,167.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M284.3,169.3c0,0,12.1,28.4,13.4,57s-49.3,68.1-49.3,68.1s-39-26.8-69.1-24.4c-30.1,2.4-39.4,13.1-39.4,13.1 s23.4-50,64.1-67.5c0,0-8.4-28.8,4.5-47.8C208.6,167.8,236.7,177,284.3,169.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M297.7,226.4c0,0.8,0,1.6,0,2.4c-0.1,1.3-0.2,2.5-0.5,3.7c-0.6,2.9-1.4,5.7-2.6,8.4l0,0 c-3.6,7.9-8.3,15.3-14,22c-2.9,3.5-5.9,6.9-8.9,10c-7.3,7.7-15.1,14.9-23.3,21.5c-10.2-6.8-21.1-12.5-32.5-17.1 c-3.5-1.4-7.1-2.7-10.7-3.8l0,0c-8.3-2.7-17.1-3.8-25.8-3.4c-8.3,0.6-16.6,2.2-24.5,4.8c-1.4,0.5-2.6,1-3.8,1.5l-1,0.5 c-2.5,1.1-5,2.5-7.2,4c-0.3,0.2-0.5,0.4-0.7,0.5s-0.8,0.6-1.1,0.9l-0.4,0.4c-0.1,0.1-0.2,0.2-0.3,0.3l-0.2,0.2l-0.1,0.1 c0-0.1,0.2-0.4,0.5-1l0.5-0.9c0.5-0.9,1.1-2.2,2-3.8l0.4-0.7l0.7-1.2c0.2-0.4,0.5-0.8,0.7-1.3c1-1.7,2.1-3.6,3.4-5.7 c6.9-11.2,15.2-21.6,24.5-31l0,0c3.3-3.3,6.8-6.4,10.5-9.3c6.4-5.1,13.4-9.3,20.9-12.6c-1.9-7.4-2.8-15.1-2.6-22.7 c0-2.4,0.2-4.8,0.6-7.2c0.8-6.5,3-12.7,6.6-18.1c4.2,1.2,8.4,2.1,12.7,2.7c5.6,0.9,11.2,1.4,16.9,1.7c11.4,0.5,22.8,0.1,34.1-1.2 c3.9-0.4,7.9-1,12-1.7l0.4,0.9c2.7,6.7,5,13.6,6.9,20.6c0.7,2.7,1.5,5.6,2.2,8.6c0.7,3,1.3,5.7,1.8,8.7l0,0 C296.7,214.1,297.4,220.2,297.7,226.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M286.1,249.4l-5.3,13.7c-2.9,3.5-5.9,6.9-8.9,10L261,252.8L286.1,249.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M194.1,236.4l-21.5,1.2c3.3-3.3,6.8-6.4,10.5-9.3L194.1,236.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M218.9,182.3l-2.3,22.3l-15.2-11.5c0-2.4,0.2-4.8,0.6-7.2L218.9,182.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "225.9,241.1 218.9,219.7 240.2,215.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "262.7,220.7 262.7,236.7 278,231.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M223.2,267.1l-7.2,10.1c-3.5-1.4-7.1-2.7-10.7-3.8l0,0l-5.4-12.4L223.2,267.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "168.4,251.7 179.4,256.4 168.4,263.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M154.9,274.8c-11,3.8-14.9,8.3-14.9,8.3c2.5-5,5.2-9.9,8.2-14.6L154.9,274.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "245.1,254.1 235.6,263.9 249.9,266.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "245.1,192.3 256.2,207.3 264.2,190.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M295.6,208.2l-14.3-9.4l10.3-7.9C293.1,196.1,294.6,202,295.6,208.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M297.7,228.8c-0.3,4.2-1.3,8.4-3,12.2l-6-14.7L297.7,228.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M284.7,170.3l-9,9.3l-3.4-8.6c3.9-0.4,7.9-1,12-1.7L284.7,170.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M238.2,172.2l-6.6,14.1l-10.3-15.7C226.9,171.4,232.5,171.9,238.2,172.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M297.7,226.4c0,0.8,0,1.6,0,2.4c-0.1,1.3-0.2,2.5-0.5,3.7c-11.8-18.8-9-35.7-9-35.7l5.6,2.7 c0.6,2.8,1.3,5.7,1.8,8.7l0,0C296.7,214.2,297.4,220.3,297.7,226.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M249.8,94.7c20.1-6.9,25.1,19.8,5.2,37.9s-42.8,20.3-45.4,11.1C207,134.5,219.2,105.3,249.8,94.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M229.7,93.3c10.3,0,24.9,10.5,24.9,10.5s2.1,11.2-8.2,21c-10.3,9.8-19.5,11.4-25.2,7.6 c-5.7-3.8-7.3-18.6-7.3-18.6c1.1-3.5,3.8-6.4,7.3-7.5C221.3,106.2,222.9,93.4,229.7,93.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M246.5,124.8c-10.3,9.8-19.5,11.4-25.2,7.6c-1-0.7-1.9-1.6-2.5-2.6c-3.7-5.6-4.8-15.9-4.8-15.9 c9.8,11.8,21.2-0.4,22.7-8.6c0.9-4,0-8.2-2.6-11.3c6.8,1.5,14.2,5.8,18,8.2c1.7,1,2.6,1.7,2.6,1.7S256.7,115,246.5,124.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M246.5,124.8c-10.3,9.8-19.5,11.4-25.2,7.6c-1-0.7-1.9-1.6-2.5-2.6c10.3,3.1,22.5-2,29.1-11.2 c3.5-4.7,5-10.6,4.2-16.5c1.7,1,2.6,1.7,2.6,1.7S256.7,115,246.5,124.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M284.3,169.3c0,0-7.9,16,11.3,41.4l42.4-31.1l-16.9-30.7L284.3,169.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M338.1,179.6l-11.1,8.1l-16.4,12l-15,11c-1-1.3-1.9-2.6-2.7-3.8c-1.7-2.5-3.3-5.1-4.7-7.8 c-3.4-6.3-5.3-13.3-5.5-20.5c-0.1-3.2,0.5-6.4,1.7-9.4l9.4-5.2l16.2-9l7.1-4l4-2.2L338.1,179.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "327,187.7 310.6,199.7 303.4,183.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "325.5,161.9 310.4,167.9 310,155.1 317.1,151.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M299.1,174.4l-16.4,4.3c-0.1-3.2,0.5-6.4,1.7-9.4l9.4-5.2L299.1,174.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M295.6,194.9l-2.8,12c-1.7-2.5-3.3-5.1-4.7-7.8L295.6,194.9z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Suitcase--inject-193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M400,457.7l-26.1-2.1l8.6-110l26.2,2L400,457.7z M379.3,451l16.1,1.3l7.8-99.9l-16.1-1.3L379.3,451z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M382,599.5l3.4,0.3c3.7-0.1,6.8,2.9,6.9,6.7c0.1,3.7-2.9,6.8-6.7,6.9c-0.4,0-0.8,0-1.3-0.1L381,613 c-3.7,0.1-6.8-2.9-6.9-6.6c-0.1-3.7,2.9-6.8,6.6-6.9C381.2,599.4,381.6,599.5,382,599.5L382,599.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M374.7,605.6c-0.3,3.8,2.5,7.1,6.3,7.4c3.8,0.3,7.1-2.5,7.4-6.3c0.3-3.8-2.5-7.1-6.3-7.4c0,0,0,0,0,0 c-3.7-0.3-7,2.4-7.4,6.1C374.7,605.5,374.7,605.5,374.7,605.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M363.6,598.1l3.4,0.3c3.7-0.1,6.8,2.9,6.9,6.6c0.1,3.7-2.9,6.8-6.6,6.9c-0.4,0-0.9,0-1.3-0.1l-3.4-0.3 c-3.7,0.1-6.8-2.9-6.9-6.6c-0.1-3.7,2.9-6.8,6.6-6.9C362.7,598,363.1,598,363.6,598.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M356.2,604.1c-0.3,3.8,2.5,7.1,6.3,7.4c3.8,0.3,7.1-2.5,7.4-6.3c0.3-3.8-2.5-7.1-6.3-7.4c0,0,0,0,0,0 C359.8,597.6,356.5,600.4,356.2,604.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M386.6,602.2l-26.1-2c-2.5-0.2-4.4-2.4-4.2-4.9l12.4-158.9c0.2-2.5,2.4-4.4,4.9-4.2l26.1,2 c2.5,0.2,4.4,2.4,4.2,4.9L391.5,598C391.3,600.5,389.1,602.4,386.6,602.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M386.7,602.2l-13.1-1c-2.5-0.2-4.4-2.4-4.2-4.9l12.4-158.9c0.2-2.5,2.4-4.4,4.9-4.2l13.1,1 c2.5,0.2,4.4,2.4,4.2,4.9L391.5,598C391.3,600.5,389.2,602.3,386.7,602.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M405.8,351.1l-22-1.8c-1.9-0.1-3.3-1.8-3.1-3.6l0.2-2.1c0.1-1.9,1.8-3.3,3.6-3.1l22,1.8 c1.9,0.1,3.3,1.8,3.1,3.6l-0.2,2.1C409.3,349.9,407.7,351.3,405.8,351.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M405.8,351.1l-22-1.8c-1.9-0.1-3.3-1.8-3.1-3.6l0.2-2.1c0.1-1.9,1.8-3.3,3.6-3.1l22,1.8 c1.9,0.1,3.3,1.8,3.1,3.6l-0.2,2.1C409.3,349.9,407.7,351.3,405.8,351.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M386.1,351.7l-1.8-0.1c-1.9-0.1-3.3-1.8-3.1-3.6l0.2-2.1c0.1-1.9,1.8-3.3,3.6-3.1l1.8,0.1 c1.9,0.1,3.3,1.8,3.1,3.6l-0.2,2.1C389.6,350.4,388,351.8,386.1,351.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M452.6,451l-11.3,143.6c-0.4,5.3-5,9.2-10.3,8.8l-52.4-4.1c-3.7-0.3-6.4-3.5-6.2-7.2l11.6-149.3 c0.3-3.7,3.5-6.5,7.2-6.2l52.4,4.1C449,441.1,453,445.7,452.6,451C452.6,451,452.6,451,452.6,451z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M452.4,451.3l-11.3,143.6c-0.4,5.3-5,9.2-10.3,8.8l-52.4-4.1c-3.7-0.3-6.4-3.5-6.2-7.2l11.6-149.3 c0.3-3.7,3.5-6.5,7.2-6.2l52.4,4.1C448.8,441.4,452.8,446,452.4,451.3C452.4,451.3,452.4,451.3,452.4,451.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M416.6,438.6v0.2l-1.9-0.2c-3.7-0.3-6.9,2.5-7.2,6.2l-11.7,149.3c-0.2,3.1,1.7,5.9,4.6,6.9l-21.8-1.7 c-3.7-0.3-6.5-3.5-6.2-7.2l11.7-149.3c0.3-3.7,3.5-6.5,7.2-6.2L416.6,438.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M415.4,443.8l0.8,0.1c1,0.1,1.8,1,1.7,2l-11.5,146.3c-0.1,1-1,1.8-2,1.7l-0.8-0.1c-1-0.1-1.8-1-1.7-2 l11.5-146.3C413.5,444.4,414.3,443.7,415.4,443.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M425.8,445.3l0.8,0.1c1,0.1,1.8,1,1.7,2l-11.5,146.3c-0.1,1-1,1.8-2,1.7l-0.8-0.1c-1-0.1-1.8-1-1.7-2 L423.9,447C423.9,446,424.8,445.2,425.8,445.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M436.3,445.9l0.8,0.1c1,0.1,1.8,1,1.7,2l-11.5,146.3c-0.1,1-1,1.8-2,1.7l-0.8-0.1c-1-0.1-1.8-1-1.7-2 l11.5-146.3C434.4,446.6,435.3,445.9,436.3,445.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M446.8,446.5l0.8,0.1c1,0.1,1.8,1,1.7,2l-11.5,146.3c-0.1,1-1,1.8-2,1.7l-0.8-0.1c-1-0.1-1.8-1-1.7-2 l11.5-146.3C444.9,447.2,445.8,446.5,446.8,446.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.b406bfe50d707753e915c5a0be601e57.svg";
export { ForwardRef as ReactComponent };